import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { MultimediaManagerDialogUploaderService } from '../multimedia-manager-dialog-uploader/multimedia-manager-dialog-uploader.service';
import { map, tap } from 'rxjs/operators';
import { MultimediaManagerDialogService } from '../multimedia-manager-dialog/multimedia-manager-dialog.service';
import { Mode } from '../multimedia-manager-dialog/multimedia-manager-dialog.component';
import { MultimediaManagerDialogItemTypes } from '../multimedia-manager-dialog/multimedia-manager-dialog-item.model';

@Component({
  selector: 'app-multimedia-manager-dialog-editor',
  templateUrl: './multimedia-manager-dialog-editor.component.html',
  styleUrls: ['./multimedia-manager-dialog-editor.component.scss']
})
export class MultimediaManagerDialogEditorComponent implements OnInit {

  @Input() data;
  @Input() element;
  @Output() result = new EventEmitter<any>();

  constructor(private multimediaManagerDialogService: MultimediaManagerDialogService,
              private multimediaManagerDialogUploaderService: MultimediaManagerDialogUploaderService) { }

  ngOnInit() { }

  public resultReceiver(result) {
    const element = {
      data: result,
      name: 'EDIT_' + new Date().toLocaleString().replace(' ', '_'),
      type: MultimediaManagerDialogItemTypes.WEB_SCRIPT,
      destinyFolderId: this.multimediaManagerDialogService.getCurrentFolder().InternalId
    };
    this.element.Type === MultimediaManagerDialogItemTypes.WEB_SCRIPT ? this._updateElement(this.element.InternalId, element) : this._saveElement(element);
  }

  private _updateElement(internalId, element) {
    const elementsArray = [{internalId}];
    this.multimediaManagerDialogUploaderService.deleteElement(elementsArray).pipe(
      tap(
        res => this.multimediaManagerDialogUploaderService.saveElement(element).pipe(
          tap(res2 => this.multimediaManagerDialogService.folderChanged(this.multimediaManagerDialogService.getCurrentFolder())),
          tap(res2 => this.multimediaManagerDialogService.setMode(Mode.finder, null))

      ).subscribe())

    ).subscribe();
  }

  private _saveElement(element) {
    this.multimediaManagerDialogUploaderService.saveElement(element).pipe(
      tap(o => this.multimediaManagerDialogService.folderChanged(this.multimediaManagerDialogService.getCurrentFolder())),
      tap(o => this.multimediaManagerDialogService.setMode(Mode.finder, null))
    ).subscribe();
  }
}
